/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APICustomerRequest
 */
export interface APICustomerRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof APICustomerRequest
     */
    contacts?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof APICustomerRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof APICustomerRequest
     */
    ustId?: string;
}

/**
 * Check if a given object implements the APICustomerRequest interface.
 */
export function instanceOfAPICustomerRequest(value: object): value is APICustomerRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function APICustomerRequestFromJSON(json: any): APICustomerRequest {
    return APICustomerRequestFromJSONTyped(json, false);
}

export function APICustomerRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APICustomerRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'contacts': json['contacts'] == null ? undefined : json['contacts'],
        'name': json['name'],
        'ustId': json['ust_id'] == null ? undefined : json['ust_id'],
    };
}

export function APICustomerRequestToJSON(value?: APICustomerRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'contacts': value['contacts'],
        'name': value['name'],
        'ust_id': value['ustId'],
    };
}

